export default function (name, type, size, color = null) {
  const hrefForSvg = `${type}/${size}/${name}`;

  return `
    <svg
      width="${size}"
      height="${size}"
      viewBox="0 0 ${size} ${size}"
      xmlns="http://www.w3.org/2000/svg"
      ${color ? 'style="color:${color};"' : ''}
    >
      <use
        xmlns:xlink="http://www.w3.org/2000/svg"
        xlink:href="#icons/${hrefForSvg}"
        href="#icons/${hrefForSvg}"
      ></use>
    </svg>
  `;
}
